"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultBooleanValue = exports.useBooleanField = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _useFormField = require("./useFormField");

var useBooleanField = function useBooleanField(state, dispatch) {
  var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var valueFromChange = function valueFromChange(event) {
    return event.target.checked;
  };

  var result = (0, _useFormField.useFormField)(state, dispatch, (0, _objectSpread2.default)({}, args, {
    valueFromChange: valueFromChange
  }));
  result.props.checked = result.props.value;
  return result;
};

exports.useBooleanField = useBooleanField;
var defaultBooleanValue = false;
exports.defaultBooleanValue = defaultBooleanValue;